import * as React from 'react'
import { Helmet } from 'react-helmet'
import { getDistance } from 'geolib'
import { withRouter } from 'react-router'

// components
import FeaturedCard from '../../../../components/home/FeaturedCard/FeaturedCard'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import FeatureMaintenanceModal from '../../../../components/home/FeatureMaintenanceModal/FeatureMaintenanceModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import ShopDineCard from '../../../../components/home/ShopDineCard/ShopDineCard'
import DashboardLayout from '../../../../components/ui/DashboardLayout/DashboardLayout'
import CardListModal from '../../../../components/ui/CardListModal/CardListModal'
import ArticleCard from '../../../../components/ui/ArticleCard/ArticleCard'
import Section from '../../../../components/ui/Section/Section'
import Icon from '../../../../components/ui/Icon/Icon'
import SelectMallPromptModal from '../../../../components/home/SelectMallPromptModal/SelectMallPromptModal'
import MallWelcomeModal from '../../../../components/home/MallWelcomeModal/MallWelcomeModal'
import LeaveModal from '../../../../components/home/LeaveModal/LeaveModal'
import SliderLoader from '../../../../components/home/SliderLoader/SliderLoader'
import {
  ButtonNav,
  ButtonNavWrapper,
  DefaultBannerTitle,
  BannerTitleContainer,
  BannerTitle,
  sectionDescription,
} from './MainView.style'

// ads
import DesktopLeaderboard from '../../../../components/ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../../../components/ads/MobileRectangle/MobileRectangle'
import ResponsiveAdsContainer from '../../../../components/ads/ResponsiveAdsContainer/ResponsiveAdsContainer'
// import HeaderPageLeaderboard from '../../../../components/ads/HeaderPageLeaderboard/HeaderPageLeaderboard'
// import HeaderPageRectangle from '../../../../components/ads/HeaderPageRectangle/HeaderPageRectangle'

// assets
import ExploreBannerImage from '../../../../assets/img/exploreBanner.webp'

// api requests
import * as DashboardApiService from '../../../../services/api/requests/Dashboard'
import * as MallApiService from '../../../../services/api/requests/Mall'

// data
import filterString from '../../../../services/data/filterString'
import viewTypeBaseUrl from '../../../../services/data/viewTypeBaseUrl'
import { EXPLORE as EXPLORE_APPEARANCE } from '../../../../services/data/marketingContentAppearance'
import getDeviceLocation from '../../../../services/location/getDeviceLocation'
import getMarketingContentLabel from '../../../../services/data/getMarketingContentLabel'
import {
  EXPLORE_TOPPICKS,
  EXPLORE_TOPPICKS_EMPTY,
  EXPLORE_ORDER,
  EXPLORE_SHOP,
  EXPLORE_DINE,
  EXPLORE_UNWIND,
} from '../../../../services/data/errorNames.json'

//analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import {
  doGetExploreOrders,
  doGetExploreShops,
  doGetExploreDine,
  doGetExploreUnwind,
  doGetExploreStore,
  doGetExploreMerchant,
  doGetExploreBannerDescription,
  doGetContentTypeExplore,
} from '../../../../controllers/Explore'
import {
  doGetFavoriteMalls,
  doSetFavoriteMalls,
} from '../../../../controllers/Profile'
import {
  FEATURES_LIST,
  withFeatureMaintenance,
} from '../../../../services/hooks/useFeatureMaintenance'
import { getSelectedPreferences } from '../../../../services/api/requests/Preferences'

const EXPLORE = doGetContentTypeExplore()

class MainView extends React.Component {
  constructor(props) {
    super(props)

    this.featuredSlider = React.createRef()
    this.orderSlider = React.createRef()
    this.shopSlider = React.createRef()
    this.dineSlider = React.createRef()
    this.unwindSlider = React.createRef()
    this.loadingSlider = React.createRef()

    const {
      match,
      setMalls,
      accessToken,
      preferenceIds,
      setHeroBanners,
      featureMaintenance: { refreshFeatureStatus },
    } = props

    const { mallSlug = '' } = match.params

    this.state = {
      currentMall: mallSlug !== 'malls' ? mallSlug : '',
      showFavoriteConfirm: false,
      favoriteMalls: [],
      searchModalState: false,
      selectModalState: mallSlug === '' || mallSlug === 'malls',
      position: null,
      cardListModalOption: {},
      showLeaveModal: false,
      selectedBrand: {},
      isReversed: false,
      orderLoaded: false,
      shopLoaded: false,
      dineLoaded: false,
      unwindLoaded: false,
      promoCode: '',
      showMaintenanceModal: false,
    }

    const bannerPromise = Promise.all([
      DashboardApiService.getHeroBanners(),
      MallApiService.getAllMalls(),
    ])

    bannerPromise.then(response => {
      const [dashboardReponse, mallReponse] = response

      setHeroBanners(dashboardReponse.data)
      setMalls(mallReponse.data)

      this.setHeaderBanner(dashboardReponse.data, mallReponse.data)
    })

    if (
      accessToken &&
      (preferenceIds === null ||
        (Array.isArray(preferenceIds) && preferenceIds.length === 0))
    ) {
      this.getUserPreferences()
    } else {
      this.getMerchants()
    }

    this.getFavoriteMall()
    refreshFeatureStatus()
  }

  componentWillMount() {
    const { waitRenderServer } = this.props

    waitRenderServer(true)

    this.displayModal()
  }

  componentWillUnmount() {
    const {
      setMerchantOrder,
      setMerchantUnwind,
      setMerchantShop,
      setMerchantDine,
    } = this.props
    setMerchantOrder([])
    setMerchantUnwind([])
    setMerchantShop([])
    setMerchantDine([])
  }

  componentDidMount() {
    const { location, getMappedinKeys } = this.props
    getDeviceLocation().then(this.getPosition)
    setGAPageView(location.pathname)
    getMappedinKeys && getMappedinKeys()
  }

  componentDidUpdate(prevProps) {
    const {
      push,
      match,
      heroBanners,
      malls,
      location,
      selectedMallSlug,
      baseUrl,
    } = this.props
    const { mallSlug, viewType, viewId } = match.params
    const { selectedMallSlug: prevSelectedMallSlug } = prevProps
    const {
      mallSlug: prevMallSlug,
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (mallSlug !== prevMallSlug) {
      this.setHeaderBanner(heroBanners, malls)
      this.getMerchants()
    }

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (prevProps.location.pathname !== location.pathname) {
      setGAPageView(location.pathname)
    }
    if (
      selectedMallSlug &&
      (prevSelectedMallSlug !== selectedMallSlug ||
        mallSlug !== selectedMallSlug)
    )
      push(
        `${baseUrl}/${selectedMallSlug}${
          viewType ? `/${viewType}${viewId ? `/${viewId}` : ''}` : ''
        }`,
      )
  }

  getUserPreferences = async () => {
    try {
      const { accessToken, setPreferenceIds } = this.props
      const { data } = await getSelectedPreferences(accessToken)

      setPreferenceIds(data.ids || [])
      this.getMerchants()
    } catch (e) {}
  }

  getPosition = position => {
    this.setState({
      position: {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      },
    })
  }

  getMerchants = async () => {
    const { match } = this.props
    const { mallSlug = '' } = match.params

    if (mallSlug && mallSlug !== 'malls') {
      this.setState({})
      await this.getExploreOrder(mallSlug)

      this.getExploreShops(mallSlug)
      this.getExploreDine(mallSlug)
      this.getExploreUnwind(mallSlug)
      this.getExplorePopular()
    }
  }

  getExplorePopular = () => {
    const {
      // accessToken,
      setMerchantPopular,
      setError,
      removeError,
      errorList,
      doGetFeaturedMarketingContent,
    } = this.props

    const pageLoadStart = Date.now()

    if (errorList.length) removeError(EXPLORE_TOPPICKS)

    doGetFeaturedMarketingContent({
      setFeatured: setMerchantPopular,
      onSuccess: data => {
        if (!data.length) {
          setError({
            name: EXPLORE_TOPPICKS_EMPTY,
          })
        }
        setGAEvent(
          'page',
          'loading_duration',
          'explore_top_picks',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: EXPLORE_TOPPICKS,
          error: error.message,
        })
      },
    })(10, EXPLORE_APPEARANCE)
  }

  getExploreOrder = async mallSlug => {
    const {
      accessToken,
      setMerchantOrder,
      setError,
      removeError,
      errorList,
    } = this.props

    const pageLoadStart = Date.now()

    await doGetExploreOrders({
      accessToken,
      setMerchantOrder,
      setError,
      removeError,
      errorList,
      onSuccess: data => {
        this.setState({
          isReversed: data && data.length > 0,
          orderLoaded: true,
        })
        setGAEvent(
          'page',
          'loading_duration',
          'order',
          Date.now() - pageLoadStart,
        )
      },
    })(9, mallSlug)
  }

  getExploreShops = async mallSlug => {
    const {
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantShop,
    } = this.props

    setMerchantShop([])
    const pageLoadStart = Date.now()

    await doGetExploreShops({
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantShop,
      collectionType: EXPLORE,
      onSuccess: () => {
        this.setState({ shopLoaded: true })
        setGAEvent(
          'page',
          'loading_duration',
          'shop',
          Date.now() - pageLoadStart,
        )
      },
    })(9, mallSlug)
  }

  getExploreDine = async mallSlug => {
    const {
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantDine,
    } = this.props

    setMerchantDine([])
    const pageLoadStart = Date.now()

    await doGetExploreDine({
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantDine,
      collectionType: EXPLORE,
      onSuccess: () => {
        this.setState({ dineLoaded: true })
        setGAEvent(
          'page',
          'loading_duration',
          'dine',
          Date.now() - pageLoadStart,
        )
      },
    })(9, mallSlug)
  }

  getExploreUnwind = async mallSlug => {
    const {
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantUnwind,
    } = this.props

    setMerchantUnwind([])
    const pageLoadStart = Date.now()

    await doGetExploreUnwind({
      setError,
      errorList,
      removeError,
      preferenceIds,
      setMerchantUnwind,
      collectionType: EXPLORE,
      onSuccess: () => {
        this.setState({ unwindLoaded: true })
        setGAEvent(
          'page',
          'loading_duration',
          'unwind',
          Date.now() - pageLoadStart,
        )
      },
    })(9, mallSlug)
  }

  getFavoriteMall = () => {
    const { accessToken, setFavoriteMalls } = this.props
    doGetFavoriteMalls({ accessToken, setFavoriteMalls })
  }

  onSelectMallClick = () => {
    this.setState({
      searchModalState: true,
    })
  }

  onChangeMall = async mallSlugName => {
    const {
      push,
      malls,
      accessToken,
      showAddFavorite,
      disableFavoritePrompt,
      favoriteMalls,
      // match,
    } = this.props

    if (push) {
      this.setState({
        searchModalState: false,
      })

      window.location.reload()
    }

    const favoriteMallsSlugNames = favoriteMalls.map(mall => mall.slugName)

    const currentMall = malls.find(mall => mall.slugName === mallSlugName)

    if (accessToken && showAddFavorite) {
      if (!favoriteMallsSlugNames.includes(mallSlugName)) {
        this.setState({
          showFavoriteConfirm: true,
        })
        disableFavoritePrompt()
      }
    }

    setGAEvent('explore_mall', 'select_mall', currentMall.name)
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setMerchantModalData,
      setMerchantModalStatus,
      setCardListModalStatus,
      selectedMallSlug,
    } = this.props
    if (push) {
      push(`${baseUrl}${selectedMallSlug ? `/${selectedMallSlug}` : ''}`)
      setMerchantModalData(null)
      setMerchantModalStatus(null)
      setCardListModalStatus(null)
    }
  }

  featuredSliderNext = () => {
    this.featuredSlider.current.slickNext()
  }

  featuredSliderPrev = () => {
    this.featuredSlider.current.slickPrev()
  }

  orderSliderNext = () => {
    this.orderSlider.current.slickNext()
  }

  orderSliderPrev = () => {
    this.orderSlider.current.slickPrev()
  }

  shopSliderNext = () => {
    this.shopSlider.current.slickNext()
  }

  shopSliderPrev = () => {
    this.shopSlider.current.slickPrev()
  }

  dineSliderNext = () => {
    this.dineSlider.current.slickNext()
  }

  dineSliderPrev = () => {
    this.dineSlider.current.slickPrev()
  }

  unwindSliderNext = () => {
    this.unwindSlider.current.slickNext()
  }

  unwindSliderPrev = () => {
    this.unwindSlider.current.slickPrev()
  }

  setFavoriteMall = async id => {
    const { accessToken } = this.props
    await doSetFavoriteMalls({
      accessToken,
      onSuccess: this.getFavoriteMall,
      callback: () => {
        this.setState({ showFavoriteConfirm: false })
      },
    })(id)
  }

  // displayFavoriteConfirm = show => {
  //   this.setState({
  //     showFavoriteConfirm: show,
  //   })
  // }

  searchModalToggle = state => {
    this.setState(oldState => ({
      searchModalState: oldState.currentMall !== '' ? state : true,
    }))
  }

  closeWelcomeModal = () => {
    const { setDisplayMallWelcome } = this.props

    setDisplayMallWelcome(false)
  }

  displayModal = async () => {
    const {
      // accessToken,
      match,
      setMerchantModalData,
      setMerchantModalStatus,
      setCardListModalData,
      setCardListModalStatus,
      renderServer,
      doGetFeaturedMarketingContent,
    } = this.props
    const { viewType, viewId = '' } = match.params

    if (viewType === 'top-picks') {
      doGetFeaturedMarketingContent({
        setFeatured: setCardListModalData,
        onSuccess: () => setCardListModalStatus(0),
        onError: () => {
          setCardListModalData([])
          setCardListModalStatus(4)
        },
      })('', EXPLORE_APPEARANCE)

      this.setState({
        cardListModalOption: sectionDescription.featured,
      })
    } else if (viewType === 'store' && viewId) {
      try {
        setCardListModalStatus(null)
        setMerchantModalStatus(1)

        const merchantModalData = await doGetExploreStore({ viewId })

        setMerchantModalData(merchantModalData)
        setMerchantModalStatus(0)
      } catch (e) {
        setMerchantModalStatus(4)
      }
    } else if (viewType === 'merchant' && viewId) {
      let merchantModalData = null

      try {
        setCardListModalStatus(null)
        setMerchantModalStatus(1)

        merchantModalData = await doGetExploreMerchant({ viewId })

        setMerchantModalData(merchantModalData)
        setMerchantModalStatus(0)
      } catch (e) {
        setMerchantModalStatus(4)
      }
    } else {
      setMerchantModalData(null)
      setMerchantModalStatus(null)
      setCardListModalStatus(null)

      setGAEvent('page', 'page_visit', 'explore')
    }
    renderServer()
  }

  setHeaderBanner = (heroBanners, malls) => {
    const { heroBanner, match, setHeroBanner } = this.props
    const { mallSlug } = match.params
    const currentMall = malls.filter(mall => mall.slugName === mallSlug)
    const mallBanner = currentMall[0] || {}

    this.setState({
      currentMall: mallBanner.slugName || '',
    })

    if (mallBanner.backgroundImageUrl) {
      setHeroBanner({
        ...heroBanner,
        desktopBanner: {
          ...heroBanner.desktopBanner,
          url: mallBanner.backgroundImageUrl,
        },
        mobileBanner: {
          ...heroBanner.mobileBanner,
          url: mallBanner.backgroundImageUrl,
        },
        layout: 0,
        isMallBanner: true,
      })
    }
  }

  displaySelectMalls = () => {
    this.setState({
      searchModalState: true,
      selectModalState: false,
    })
  }

  selectNearestMall = mallSlugName => {
    const { replace, baseUrl, match, setSelectedMallSlug } = this.props
    const { viewType, viewId } = match.params

    this.setState({
      searchModalState: false,
      selectModalState: false,
    })

    setSelectedMallSlug(mallSlugName)

    replace(
      `${baseUrl}/${mallSlugName}${
        viewType ? `/${viewType}${viewId ? `/${viewId}` : ''}` : ''
      }`,
    )
  }

  toggleMaintenanceModal = () => {
    this.setState({ showMaintenanceModal: !this.state.showMaintenanceModal })
  }

  redirectToWayfinding = slugName => {
    const {
      push,
      featureMaintenance: { isFeatureAvailable, loading },
    } = this.props

    // Only block and show modal when we know the feature is unavailable (API has loaded).
    // While loading, allow navigation so we don't show the modal on stale/empty state.
    if (!loading && !isFeatureAvailable()) {
      this.setState({ showMaintenanceModal: true })
      return
    }
    push(`/wayfinding/${slugName}`)
  }
  redirectToMallDirectory = slugName =>
    this.props.push(`/explore/mall-directory/${slugName}`)

  handleShowLeaveModal = brand => {
    this.setState({
      showLeaveModal: true,
      selectedBrand: brand,
    })
  }

  handleCloseLeaveModal = () => {
    this.setState({
      showLeaveModal: false,
    })
    setTimeout(
      () =>
        this.setState({
          selectedBrand: {},
        }),
      10,
    )
  }

  handleRedirectToLogin = () => {
    const { push } = this.props
    push('/login')
  }

  render() {
    const {
      heroBanner,
      malls,
      orderShop,
      shop,
      dine,
      unwind,
      popular,
      baseUrl,
      setFavoriteMalls,
      showMerchantModal,
      merchantModalData,
      merchantModalStatus,
      displayMallWelcome,
      allMallsError,
      displayProfileModal,
      setProfileModalPage,
      cardListModalData,
      showCardListModal,
      cardListModalStatus,
      errorList,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      ...theProps
    } = this.props

    const { accessToken, match, push } = this.props
    const { mallSlug = '' } = match.params
    const {
      currentMall,
      // showFavoriteConfirm,
      searchModalState,
      selectModalState,
      position,
      cardListModalOption,
      showLeaveModal,
      selectedBrand,
      isReversed,
      orderLoaded,
      shopLoaded,
      dineLoaded,
      unwindLoaded,
      showMaintenanceModal,
    } = this.state

    const currentMallId = malls.find(
      mall => mall.slugName === currentMall && mall.explore && mall.slugName,
    )
    const exploreLink = `/wayfinding/${currentMall}`
    const linkBase = `${baseUrl}/${currentMall || 'malls'}`
    const noneActiveMalls = malls.filter(mall => !mall.explore)

    const nearestMalls =
      !!position &&
      !!malls &&
      malls
        .map(mall => {
          const mallDistance = getDistance(position, {
            latitude: mall.latitude,
            longitude: mall.longitude,
          })

          return {
            ...mall,
            distance: mallDistance,
          }
        })
        .filter(mall => mall.distance <= 5000 && mall.explore && mall.slugName)
        .sort((a, b) => a.distance - b.distance)

    let displayWelcomeModal = false

    if (
      displayMallWelcome &&
      noneActiveMalls.length &&
      nearestMalls.length > 0 &&
      mallSlug === ''
    ) {
      displayWelcomeModal = true
    }

    const forceFavoriteMall = malls
      .filter(mall => mall.favorite && mall.explore && mall.slugName)
      .sort((a, b) => a.name.localeCompare(b.name))

    if (mallSlug === '' && forceFavoriteMall.length) {
      this.selectNearestMall(forceFavoriteMall[0].slugName)

      return <></>
    }
    if (mallSlug === '' && nearestMalls.length) {
      const nearestMallSlugName = nearestMalls[0].slugName
      this.selectNearestMall(nearestMallSlugName)

      return <></>
    }

    let HeroBannerBackground = ExploreBannerImage
    let heroBannerCaption = doGetExploreBannerDescription()
    let HeroBannerImage = DefaultBannerTitle

    const currentMallPhotos = currentMallId ? currentMallId.photos : ''

    if (currentMallId) {
      heroBannerCaption = currentMallId.description
      HeroBannerImage = () => (
        <BannerTitleContainer>
          <BannerTitle
            style={{
              maskImage: `url('${currentMallId.iconUrl}')`,
              WebkitMaskImage: `url('${currentMallId.iconUrl}')`,
            }}
          />
        </BannerTitleContainer>
      )
    }

    if (currentMallPhotos && currentMallPhotos.length) {
      HeroBannerBackground = currentMallPhotos[0].url
    }

    if (currentMall && !currentMallId && malls.length) {
      push(baseUrl)
    }

    const selectedMallSlugName =
      currentMallId && currentMallId.slugName ? currentMallId.slugName : null
    const selectedMallId =
      currentMallId && currentMallId.id ? currentMallId.id : null

    const selectedMallUrl = selectedMallSlugName || selectedMallId || null

    return (
      <DashboardLayout
        heroBannerData={{
          desktopBanner: {
            url: HeroBannerBackground,
          },
          caption: heroBannerCaption,
          layout: 0,
        }}
        heroBannerTitle={() => <HeroBannerImage />}
        displayProfileModal={displayProfileModal}
        setProfileModalPage={setProfileModalPage}
        heroLink={exploreLink}
        handleChangeMall={this.onSelectMallClick}
        redirectToWayfinding={this.redirectToWayfinding}
        redirectToMallDirectory={this.redirectToMallDirectory}
        selectedMall={currentMallId}
        showMallDropdown
        actionLabel="View Mall Map"
        readMoreLink={selectedMallUrl ? `/main/malls/${selectedMallUrl}` : null}
        selectedMallSlugName={selectedMallSlugName}
        errors={allMallsError}
        variant="explore"
        dropdownCaption="Select Mall"
        featuredSection={
          !errorList.find(error => error.name === EXPLORE_TOPPICKS_EMPTY) && (
            <>
              <CardSlider
                dataSource={popular}
                loadingComponent={() => (
                  <FeaturedCard
                    key={JSON.stringify(errorList)}
                    loading
                    error={errorList.find(
                      error =>
                        error.name === EXPLORE_TOPPICKS ||
                        error.name === EXPLORE_TOPPICKS_EMPTY,
                    )}
                    onRetry={() => this.getExplorePopular()}
                  />
                )}
                renderItem={(item, index) => {
                  const newIndex = index + 1
                  const newId = popular.length === newIndex ? 0 : newIndex

                  return (
                    <FeaturedCard
                      key={item.itemId}
                      id={newId}
                      featuredImgUrl={item.logoUrl}
                      bannerImgUrl={item.imageUrl}
                      schedule={item.schedule}
                      title={item.title}
                      body={filterString(item.description)}
                      item={item}
                      // label={item.customLabel}
                      label={getMarketingContentLabel(item).name}
                      link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
                      onClick={() =>
                        setGAEvent(
                          'item_clicks',
                          'view_explore_top_picks_item',
                          item.title,
                        )
                      }
                    />
                  )
                }}
                onViewAllClick={() => push(`${linkBase}/top-picks`)}
                ref={this.featuredSlider}
                featured
              />
              {popular.length > 1 && (
                <>
                  <ButtonNavWrapper left>
                    <ButtonNav onClick={this.featuredSliderPrev}>
                      <Icon name="slide-left" />
                    </ButtonNav>
                  </ButtonNavWrapper>

                  <ButtonNavWrapper>
                    <ButtonNav onClick={this.featuredSliderNext} right>
                      <Icon name="slide-right" />
                    </ButtonNav>
                  </ButtonNavWrapper>
                </>
              )}
            </>
          )
        }
        altFooterAd
        {...theProps}
      >
        {!!malls.length && (
          <>
            {orderShop && orderShop.length > 0 && (
              <>
                <Section
                  sectionTitle={sectionDescription.order.title}
                  sectionText={sectionDescription.order.description}
                  sectionContentType="small"
                  sliderNext={this.orderSliderNext}
                  sliderPrev={this.orderSliderPrev}
                  to={`${linkBase}/view-all/order`}
                >
                  <SliderLoader
                    key={'order-slider'}
                    dataLoaded={orderLoaded}
                    ref={this.orderSlider}
                    hasError={errorList.find(
                      error => error.name === EXPLORE_ORDER,
                    )}
                    loadingComponent={() => (
                      <ShopDineCard
                        loading
                        error={errorList.find(
                          error => error.name === EXPLORE_ORDER,
                        )}
                        errorMessage="Failed to load Shop."
                        onRetry={() => this.getExploreOrder(mallSlug)}
                      />
                    )}
                    sliderData={{
                      dataSource: orderShop,
                      renderItem: item => (
                        <ShopDineCard
                          key={item.itemId || item.id}
                          iconUrl={item.logoUrl}
                          cardImageUrl={item.backgroundUrl}
                          title={item.title || item.name}
                          link={`${linkBase}`}
                          onClick={() => {
                            this.handleShowLeaveModal(item)
                            setGAEvent(
                              'item_clicks',
                              'view_order_item',
                              item.title,
                            )
                          }}
                        />
                      ),
                    }}
                  />
                </Section>
                <ResponsiveAdsContainer
                  desktop={<DesktopLeaderboard id="div-ad-innity-91042/19" />}
                  mobile={<MobileRectangle id="div-ad-innity-91046/19" />}
                />
              </>
            )}
            {(!shopLoaded || (shopLoaded && shop.length > 0)) && (
              <>
                <Section
                  sectionTitle={sectionDescription.shop.title}
                  sectionText={sectionDescription.shop.description}
                  sectionContentType="small"
                  sliderNext={this.shopSliderNext}
                  sliderPrev={this.shopSliderPrev}
                  to={`${linkBase}/view-all/shop`}
                  contentDirection={isReversed && 'rtl'}
                  reverse={isReversed}
                  onClick={() =>
                    setGAEvent(
                      'home_section',
                      'section_view_all_click',
                      'shop_view_all',
                    )
                  }
                >
                  <SliderLoader
                    key="shop-slider"
                    dataLoaded={shopLoaded}
                    ref={this.shopSlider}
                    reversedLoading={true}
                    hasError={errorList.find(
                      error => error.name === EXPLORE_SHOP,
                    )}
                    loadingComponent={() => (
                      <ShopDineCard
                        loading
                        error={errorList.find(
                          error => error.name === EXPLORE_SHOP,
                        )}
                        errorMessage="Failed to load Shop."
                        onRetry={() => this.getExploreShops(mallSlug)}
                      />
                    )}
                    sliderData={{
                      dataSource: shop,
                      initialSlide: isReversed ? shop.length - 1 : 0,
                      renderItem: item => (
                        <ShopDineCard
                          key={item.itemId}
                          iconUrl={item.logoUrl}
                          cardImageUrl={item.imageUrl}
                          title={item.title}
                          link={`${viewTypeBaseUrl(
                            item.type,
                            currentMall,
                            true,
                          )}/${item.itemId}`}
                          onClick={() =>
                            setGAEvent(
                              'item_clicks',
                              'view_shop_item',
                              item.title,
                            )
                          }
                        />
                      ),
                    }}
                  />
                </Section>
                {/* <ResponsiveAdsContainer
                  desktop={<HeaderPageLeaderboard id="div-totalmedia-3a" />}
                  mobile={<HeaderPageRectangle id="div-totalmedia-3b" />}
                /> */}
                <ResponsiveAdsContainer
                  desktop={<DesktopLeaderboard id="div-ad-innity-91042/3" />}
                  mobile={<MobileRectangle id="div-ad-innity-91046/3" />}
                />
              </>
            )}
            {(!dineLoaded || (dineLoaded && dine.length > 0)) && (
              <>
                <Section
                  sectionTitle={sectionDescription.dine.title}
                  sectionText={sectionDescription.dine.description}
                  sectionContentType="small"
                  sliderNext={this.dineSliderNext}
                  sliderPrev={this.dineSliderPrev}
                  to={`${linkBase}/view-all/dine`}
                  contentDirection={!isReversed && 'rtl'}
                  reverse={!isReversed}
                  onClick={() =>
                    setGAEvent(
                      'home_section',
                      'section_view_all_click',
                      'dine_view_all',
                    )
                  }
                >
                  <SliderLoader
                    key={'dine-slider'}
                    ref={this.dineSlider}
                    dataLoaded={dineLoaded}
                    hasError={errorList.find(
                      error => error.name === EXPLORE_DINE,
                    )}
                    loadingComponent={() => (
                      <ShopDineCard
                        loading
                        error={errorList.find(
                          error => error.name === EXPLORE_DINE,
                        )}
                        errorMessage="Failed to load Dine."
                        onRetry={() => this.getExploreDine(mallSlug)}
                      />
                    )}
                    sliderData={{
                      dataSource: dine,
                      initialSlide: !isReversed ? dine.length - 1 : 0,
                      renderItem: (item, index) => (
                        <ShopDineCard
                          key={item.itemId}
                          id={dine.length - (index + 1)}
                          iconUrl={item.logoUrl}
                          cardImageUrl={item.imageUrl}
                          title={item.title}
                          link={`${viewTypeBaseUrl(
                            item.type,
                            currentMall,
                            true,
                          )}/${item.itemId}`}
                          onClick={() =>
                            setGAEvent(
                              'item_clicks',
                              'view_dine_item',
                              item.title,
                            )
                          }
                        />
                      ),
                    }}
                  />
                </Section>
                <ResponsiveAdsContainer
                  desktop={<DesktopLeaderboard id="div-ad-innity-91042/4" />}
                  mobile={<MobileRectangle id="div-ad-innity-91046/4" />}
                />
              </>
            )}
            {(!unwindLoaded || (unwindLoaded && unwind.length > 0)) && (
              <Section
                sectionTitle={sectionDescription.unwind.title}
                sectionText={sectionDescription.unwind.description}
                sectionContentType="small"
                sliderNext={this.unwindSliderNext}
                sliderPrev={this.unwindSliderPrev}
                to={`${linkBase}/view-all/unwind`}
                contentDirection={isReversed && 'rtl'}
                reverse={isReversed}
                onClick={() =>
                  setGAEvent(
                    'home_section',
                    'section_view_all_click',
                    'unwind_view_all',
                  )
                }
              >
                <SliderLoader
                  key={'unwind-slider'}
                  ref={this.unwindSlider}
                  reversedLoading={true}
                  hasError={errorList.find(
                    error => error.name === EXPLORE_UNWIND,
                  )}
                  loadingComponent={() => (
                    <ShopDineCard
                      loading
                      error={errorList.find(
                        error => error.name === EXPLORE_UNWIND,
                      )}
                      errorMessage="Failed to load Unwind."
                      onRetry={() => this.getExploreUnwind(mallSlug)}
                    />
                  )}
                  dataLoaded={unwindLoaded}
                  sliderData={{
                    dataSource: unwind,
                    initialSlide: isReversed ? unwind.length - 1 : 0,
                    renderItem: item => (
                      <ShopDineCard
                        key={item.itemId}
                        iconUrl={item.logoUrl}
                        cardImageUrl={item.imageUrl}
                        title={item.title}
                        link={`${viewTypeBaseUrl(
                          item.type,
                          currentMall,
                          true,
                        )}/${item.itemId}`}
                        onClick={() =>
                          setGAEvent(
                            'item_clicks',
                            'view_unwind_item',
                            item.title,
                          )
                        }
                      />
                    ),
                  }}
                />
              </Section>
            )}
            {/* {!!accessToken && (
              <FavoriteConfirmModal
                show={showFavoriteConfirm}
                data={currentMallId}
                onClose={() => this.displayFavoriteConfirm(false)}
                onConfirm={() => this.setFavoriteMall(currentMallId.id)}
              />
            )} */}
            <SelectMallPromptModal
              show={
                !showMerchantModal && selectModalState && !selectedMallSlugName
              }
              onConfirmClick={this.displaySelectMalls}
            />
            <MallWelcomeModal
              show={!showMerchantModal && displayWelcomeModal}
              malls={malls}
              onConfirmClick={this.closeWelcomeModal}
            />
            <SearchMallModal
              modalState={searchModalState}
              onClose={this.searchModalToggle}
              malls={malls}
              push={push}
              match={match}
              accessToken={accessToken}
              setFavoriteMalls={setFavoriteMalls}
              baseUrl={baseUrl}
              currentMall={currentMall}
              onChangeMall={this.onChangeMall}
              selectedMall={currentMallId}
              deviceLocation={deviceLocation}
              displayClose={currentMall !== ''}
              favoriteMalls={favoriteMalls}
              setSelectedMallSlug={setSelectedMallSlug}
            />
          </>
        )}
        <StoreModal
          malls={malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleClose}
        />
        <CardListModal
          show={showCardListModal}
          onClose={this.handleClose}
          loading={cardListModalStatus}
          title={cardListModalOption.title}
          description={cardListModalOption.description}
          source={cardListModalData}
          render={item => {
            const { title, type, subtitle, imageUrl, logoUrl } = item
            const linkBaseUrl = viewTypeBaseUrl(type)

            return (
              <ArticleCard
                key={`${type}-${item.itemId}`}
                imageUrl={imageUrl}
                logoUrl={logoUrl}
                title={title}
                schedule={subtitle}
                link={`${linkBaseUrl}/${item.itemId}`}
              />
            )
          }}
        />
        {showMerchantModal && merchantModalData && merchantModalData.merchant && (
          <Helmet defaultTitle={merchantModalData.merchant.name}>
            <meta
              property="og:title"
              content={merchantModalData.merchant.name}
            />
            <meta
              property="og:description"
              content={
                merchantModalData.merchant.description &&
                filterString(merchantModalData.merchant.description)
              }
            />
            <meta
              property="og:image"
              content={merchantModalData.merchant.bannerUrl}
            />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
        <LeaveModal
          show={showLeaveModal}
          onClose={this.handleCloseLeaveModal}
          to={
            selectedBrand.onlineShopUrl
              ? /https:\/\/[a-zA-Z0-9]+/.test(selectedBrand.onlineShopUrl)
                ? selectedBrand.onlineShopUrl
                : `https://${selectedBrand.onlineShopUrl}`
              : ''
          }
          onProceed={this.handleCloseLeaveModal}
          explore
        />
        <FeatureMaintenanceModal
          show={showMaintenanceModal}
          onConfirmClick={this.toggleMaintenanceModal}
        />
      </DashboardLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(
  withFeatureMaintenance(MainView, FEATURES_LIST.INDOOR_MAPS),
)
